import React from 'react';

export default function BankSlip() {
  return (
    <svg
      width='32'
      height='20'
      viewBox='0 0 32 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z'
        fill='#27272A'
      />
      <path
        d='M10 6.66667V5.33333C10 4.97971 10.1405 4.64057 10.3905 4.39052C10.6406 4.14048 10.9797 4 11.3333 4H12.6667M19.3333 4H20.6667C21.0203 4 21.3594 4.14048 21.6095 4.39052C21.8595 4.64057 22 4.97971 22 5.33333V6.66667M22 13.3333V14.6667C22 15.0203 21.8595 15.3594 21.6095 15.6095C21.3594 15.8595 21.0203 16 20.6667 16H19.3333M12.6667 16H11.3333C10.9797 16 10.6406 15.8595 10.3905 15.6095C10.1405 15.3594 10 15.0203 10 14.6667V13.3333M13.3333 6.66667V13.3333M16 6.66667V13.3333M19.3333 6.66667V13.3333'
        stroke='#FAFAFA'
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
